import { createApp, h } from "vue";
import List from "./components/List";
import { plugin, defaultConfig } from "@formkit/vue";

const app = createApp({
    render: () => h(List, { value: window.types ?? [] }),
});

app.use(
    plugin,
    defaultConfig({
        config: {
            classes: {
                input: 'form-control',
                wrapper: 'form-group',
            },
        },
    })
);

app.mount("#activity-prices");